import React, { useState, useEffect } from 'react'
import { Link, Redirect, useLocation } from 'react-router-dom'

import { Form, Input, Pass, Button, ValidacaoYup } from './../../components/Form'
import { useAuth } from './../../context/Auth'
import { useLayout } from './../../context/Layout'
import { useTheme } from './../../context/Theme'
import { mensagemErro } from '../../components/Layout';

import api from './../../api'
import './style.scss'

import pacote from './../../../package.json'

import ReCAPTCHA from "react-google-recaptcha";

function Login() {

    const location = useLocation()
    const [load, setLoad] = useState(false)
    const [googleLoad, setGoogleLoad] = useState(false)
    const [logado, setLogado] = useState(false)
    const [validacao, setValidacao] = useState('')

    const { setUser, getUser } = useAuth()
    const { isScreenLogin } = useLayout()
    const { theme } = useTheme()

    const params = new URLSearchParams(location.search);
    const isErrorLogin = params.get('error');

    const recaptchaRef = React.createRef();

    const validaCampos = {
        email: ValidacaoYup.string().email().required(),
        senha: ValidacaoYup.string().min(6).required()
    }

    useEffect(() => {
        isScreenLogin(true)
        return () => isScreenLogin(false)
    }, [])

    useEffect(() => {
        if (isErrorLogin) {
            mensagemErro('Falha ao realizar o login, usuário inativo.')
        }
    }, [isErrorLogin]);

    async function onLogin(data) {

        recaptchaRef.current.execute()

        setLoad(true)
        const { email, senha } = data

        const resp = await api.post('login', {
            email,
            senha
        })

        if (resp.data.type === 0) {

            const { id, nome, email, token, avatar } = resp.data.value

            /** Adicona o token para futuras requisições */
            api.defaults.headers.Authorization = `Bearer ${token}`

            /** Coloca o usuário logado em Contexto */
            setUser({
                id,
                refresh: id,
                nome,
                email,
                avatar,
                token
            })

            /** Redireciona */
            setLogado(true)
        }
        else if (resp.data.type === 1) {
            setValidacao(resp.data.mensagem)
        }

        setLoad(false)
    }

    const formUser = () => (
        <>
            {
                logado || getUser() ? <Redirect to={{ pathname: '/dash' }} /> :
                    <>
                        <Form onSubmit={onLogin} className="auth-form" validacao={validaCampos}>

                            <Input name='email' titulo='E-mail' placeholder='Digite seu e-mail' />
                            <Pass name='senha' titulo='Senha' placeholder='Digite sua senha' />

                            <div className="form-actions">
                                <Link to='/esqueci' className="forgot-password">Esqueci a senha?</Link>
                            </div>

                            <div className="submit-container">
                                <Button load={load} name='Entrar' icon={<i className="fas fa-sign-in-alt"></i>} />
                                {validacao && <div className="validaRetorno">{validacao}</div>}
                            </div>

                            <ReCAPTCHA
                                ref={recaptchaRef}
                                size='invisible'
                                sitekey="6LeEskMeAAAAAKx_X9fXZ8pJSQ2F4T4pkR5x91m9"
                                onChange={() => { }}
                            />


                        </Form>
                        <div className="google-login-container">
                            <div className="divider">
                                <span>ou</span>
                            </div>
                            <Button
                                load={googleLoad}
                                loaderColor="#757575"
                                type="button"
                                className="btn-google"
                                name="Entrar com Google"
                                icon={<i className="fab fa-google"></i>}
                                onClick={() => {
                                    setGoogleLoad(true)
                                    window.location.href = `${api.defaults.baseURL}auth/google/redirect`
                                }}
                                style={{
                                    backgroundColor: '#fff',
                                    color: '#757575',
                                    border: '1px solid #ddd',
                                    marginTop: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px'
                                }}
                            />
                        </div>
                    </>
            }
            <div className='pacote'>{pacote.version}</div>
        </>
    )

    function ImageLogo() {
        return (
            <div className="auth-logo-box">
                <a href="../analytics/analytics-index.html" className="logo logo-admin">
                    <img src="../assets/images/logo-sm.png" height="55" alt="logo" className="auth-logo" />
                </a>
            </div>
        )
    }

    function CriarCadastro() {
        return (
            <p>Ainda não tem uma conta? <a href="/cadastro">Criar uma nova conta</a></p>
        )
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <img src={theme === 'dark' ? "/assets/images/logo/logobranca.svg" : "/assets/images/logo/logo.svg"} alt="Ambientar Logo" className="login-logo" />
                    <p className='subtit'>GERENCIADOR DE LICENÇAS E CONDICIONANTES</p>
                </div>

                <div className="login-card">
                    <div className="login-form-wrapper">
                        {formUser()}
                    </div>
                </div>

                <div className="login-footer">
                    <CriarCadastro />
                </div>
            </div>
        </div>
    )
}

export default Login